export default {
  BLACK: 0, // 黑棋
  WHITE: 1, // 白棋
  EMPTY: -1, // 没填
  TRIANGLE: 2, // 三角形棋子
  NUMBER: 3, // 带数字的棋子
  chessWidth: 60,  // png图片上棋子宽度
  borderColor: 'rgb(241, 220, 144)' // 棋盘背景颜色
};
